import { QueryClient } from "@tanstack/react-query";

export const REFERRAL_QUERY_KEYS = {
  REFERRAL_CODE: "referralCode",
  REFERRAL_ELIGIBILITY: "referralEligibility",
  USER_REFERRAL_STATUS: "userReferralStatus",
  REFERRALS: "referrals",
  REFERRAL_STATS: "referralStats",
  REFEREE_ELIGIBILITY_PROGRESS: "refereeEligibilityProgress",
  REFERER_WEEKLY_ELIGIBILITY_PROGRESS: "referrerWeeklyEligibilityProgress",
  REFERRER_STATS: "referrer-stats",
  REFEREE_STATS: "referee-stats",
  REFERRAL_SETTINGS: "referral-settings",
  REFERRAL_REWARDS_CLAIMABLE: "referral-rewards-claimable",
};

/**
 * Invalidate all queries related to referral eligibility
 * @param queryClient - The query client to invalidate queries on
 */
export const invalidateReferralEligibilityQueries = async (queryClient: QueryClient) => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: [REFERRAL_QUERY_KEYS.REFEREE_ELIGIBILITY_PROGRESS] }),
    queryClient.invalidateQueries({ queryKey: [REFERRAL_QUERY_KEYS.REFERER_WEEKLY_ELIGIBILITY_PROGRESS] }),
    queryClient.invalidateQueries({ queryKey: [REFERRAL_QUERY_KEYS.REFERRAL_ELIGIBILITY] }),
  ]);
};
